<script setup lang="ts">
// import { useStorage } from "@vueuse/core";

const { t } = useI18n();
const { sourcesUrl } = useRuntimeConfig().public;
const { getItems } = useItemsController();
const { trackEvent } = useGAnalytics();
const route = useRoute();
const GFALExStore = useGFALExStore();
const appStateStore = useAppStateStore();
const merchant = appStateStore.currentMerchant;
// TODO: refactor to use schedules if modalAnnouncent is needed
// const storeOfferEndDate = "2025-07-03T12:00:00+00:00";
// const endDate = new Date(storeOfferEndDate);
// const isModalAnnouncementOpen =
//   new Date() < endDate ? useStorage("showEasterOffer", true) : ref(false);
// const closeAnnouncement = () => {
//   isModalAnnouncementOpen.value = false;
//   useStorage("showEasterOffer", false);
// };

useSeoMeta({
  title: `${t(`main.appMenu.store`)} ${"| " + t(`main.merchant.${merchant}`)}`,
  description: `${t("main.marketplaceSEO.description.store")}`,
  ogTitle: `${t(`main.appMenu.store`)} ${
    "| " + t(`main.merchant.${merchant}`)
  }`,
  ogDescription: `${t("main.marketplaceSEO.description.store")}`,
  ogImage: sourcesUrl + "/images/marketplace.jpg",
  twitterTitle: `${t(`main.appMenu.store`)} ${
    "| " + t(`main.merchant.${merchant}`)
  }`,
  twitterDescription: `${t("main.marketplaceSEO.description.store")}`,
  twitterImage: sourcesUrl + "/images/marketplace.jpg",
});

const scrollToCategory = (category: string) => {
  const element = document.getElementById(category);
  if (element) {
    const offset = 120;
    const elementPosition =
      element.getBoundingClientRect().top + window.scrollY;
    const offsetPosition = elementPosition - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  }
};

onMounted(async () => {
  // if (new Date() > new Date(storeOfferEndDate)) {
  //   isModalAnnouncementOpen.value = false;
  //   useStorage("showEasterOffer", false);
  // }
  await delay(0.2);
  if (route.query.category) {
    scrollToCategory(route.query.category as string);
  }
});
</script>

<template>
  <CommonHeroMain />
  <template v-if="merchant === 'diamond-dreams'">
    <StoreDisplay :category-ids="['JEWELS']" />
    <CraftDisplay />
    <StoreDisplay :category-ids="['BUNDLES', 'CASH', 'AI_TICKETS']" />
  </template>
  <template v-else>
    <CraftDisplay />
    <StoreDisplay />
  </template>
</template>

<style scoped>
.category-gradient {
  background: radial-gradient(
    circle,
    rgba(47, 47, 47, 1) 0%,
    rgba(31, 31, 31, 1) 100%
  );
}
</style>
